import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { LayerPreview } from "./layer-preview";
import { LayerItem } from "@exibra/shared";

interface SortableLayerPreviewProps {
    layer: LayerItem;
    isSelected?: boolean;
    onSelect: (id: string) => void;
    onNameChange: (id: string, newName: string) => void;
}

export const SortableLayerPreview: React.FC<SortableLayerPreviewProps> = (props) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: props.layer.id,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    return (
        <div ref={setNodeRef} style={style}>
            <LayerPreview
                layer={props.layer}
                isSelected={props.isSelected}
                onSelect={props.onSelect}
                onNameChange={props.onNameChange}
                dragHandleProps={{ attributes, listeners }}
            />
        </div>
    );
};
